import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import InlineValue from '../InlineValue';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

// import { getTimeZoneLabel } from './TimeZoneHelpers';
import { timezonesSelector } from '../../../reducers/timezones';

const TimeZoneDisplaySelector = createSelector(
  [timezonesSelector],
  (timeZoneMap) => ({
    timeZoneMap,
  })
);

@connect(TimeZoneDisplaySelector)
export default class TimeZoneDisplay extends PureComponent {
  static propTypes = {
    userMode: PropTypes.string,
    value: PropTypes.any,
    timeZoneMap: PropTypes.instanceOf(Map),
    toggleEditor: PropTypes.func,
  };

  render = () => {
    const {
      userMode,
      value,
      timeZoneMap,
      toggleEditor,
    } = this.props;

    // const { timeZoneMap } = timeZoneData;
    const timezone = value ? timeZoneMap.getIn([value, 'text']) : undefined;

    const displayValue = (
      <InlineValue toggleEditor={toggleEditor} userMode={userMode}>
        {timezone || 'Click to edit'}
      </InlineValue>
    );

    return displayValue;
  }
}



// WEBPACK FOOTER //
// ./src/components/types/TimeZone/TimeZoneDisplay.js